<template>
  <div class="reports__view">
    <tab-navigation-panel :tabs="tabs"></tab-navigation-panel>
    <router-view></router-view>
  </div>
  
</template>
<script>

import { mapActions, mapGetters } from "vuex";
import TabNavigationPanel from '@/components/TabNavigationPanel.vue';
export default {
  name: "configuration-view",
  components: { TabNavigationPanel },
  data: () => ({ 
      view: 'USERS',
      tabs: [
        { label: "Helligdage", name: "Holiday" },
        { label: "Kredse", name: "Circles" },
        { label: "Grupper", name: "Groups" },
        { label: "Overenskomst", name: "Agreements" },
        { label: "Lønrater", name: "SalaryRates" },
        { label: "Brugere", name: "Users" },
        { label: "GPS Data", name: "GPSData"},
      ]
   }),
  async mounted() {    
    if (localStorage.configurationView && localStorage.configurationView !== "") {
      this.view = localStorage.configurationView;
    }
  },
  computed: {
    ...mapGetters(["currentUser", "hasEditRights"]),
    // IGNORE
  },
  methods: {
    setView(view) {
      this.view = view;
      localStorage.configurationView = view;
    },
  },
};
</script>


<style lang="scss">
.reports__view {
  width: calc(100vw - 16.5px);
  .reports__navigation {
    background-color: $panel;
    height: 44px;
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    padding: 0 12px;
  }

  .reports__subheader {
    background-color: $panel;
    padding: 5px 12px;
    height: 62px;

    display: flex;
    flex-flow: row wrap;
    gap: 5px;
    
    .datepicker {
      input {
        height: 30px !important;
        padding-top: 1px;
        padding-bottom: 2px;
      }
    }
    .ctrl-button {
      width: 100%;
    }
  }

  .field:not(:last-child) {
    margin-bottom: .2em;
  }
  label {
    margin-bottom: initial;
    font-size: .75em;
    font-weight: 600;
    &:not(:last-child) {
      margin-bottom: initial;
    }
  }
  
  tr.column-sunday {
    color: white;
    background: rgb(77, 77, 77);
    padding: 0.5em 0.75em;
    margin: -0.5em -0.75em;
  }  
  tr.column-holiday {
    color: black;
    background: rgb(255, 243, 70);
    padding: 0.5em 0.75em;
    margin: -0.5em -0.75em;
  } 
}
@media print {   
  .tabnavigationpanel {
    display: none;
  }
  .reports__subheader {
    font-size: 10px !important;
    line-height: 1 !important;
    height: 47px !important;
  }
}
</style>
